/**
 * Binance Exchange Metadata
 *
 * Configuration, documentation links, and notes for the Binance exchange.
 */

import { BINANCE_WS_CHANNELS, BINANCE_WS_TOPOLOGY } from './ws';

import type { ExchangeId, ExchangeMetadata } from '../../lib/types';

export const BINANCE_METADATA: ExchangeMetadata = {
  id: 'binance' as ExchangeId,
  restDocs: ['https://developers.binance.com/docs/binance-spot-api-docs/rest-api'],
  wsDocs: [
    'https://developers.binance.com/docs/binance-spot-api-docs/web-socket-streams',
    'https://developers.binance.com/docs/binance-spot-api-docs/websocket-api',
  ],
  wsTopology: BINANCE_WS_TOPOLOGY,
  wsChannels: BINANCE_WS_CHANNELS,
  notes: [
    'Supports combined streams via wss://stream.binance.com:9443/stream',
    'Orderbook stream delivers deltas only; obtain a REST snapshot before establishing the feed.',
    'WebSocket API (request/response) available at wss://ws-api.binance.com:443/ws-api/v3',
  ],
};
